export const formatExamDate = (dateString: string): string => {
  const date = new Date(dateString);

  // Format for date part: dd month YYYY
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  // Format for time part: h:mm AM/PM IST
  const timeString = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  // Combine all parts
  return `${day} ${month} ${year}, ${timeString} IST`;
};

// Example usage:
// formatExamDate("2025-05-26T11:30:00") -> "26 May 2025, 5:00 PM IST"
